var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 2L16.5 17.5L2 32","stroke":"black","strokeWidth":"3","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"width":"18","height":"34","viewBox":"0 0 18 34","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
